import type { TFunction } from 'i18next'

import { asArray } from '@mntn-dev/utilities'

import { createErrorMapRule } from '../utils/create-rule.ts'
import type { TranslationKey } from '../utils/types.ts'

export const tooBigRule = (t: TFunction<'validation'>) =>
  createErrorMapRule('too_big', t, (issue, _, t) => {
    const translate = (
      key: TranslationKey,
      options?: Record<string, unknown>
    ) => t(key, options)
    let count = 1
    const origin = issue.origin === 'int' ? 'number' : issue.origin
    switch (issue.origin) {
      case 'array':
        count = asArray(issue.input).length
        break
      case 'string':
        count = typeof issue.input === 'string' ? issue.input.length : 1
        break
      case 'set':
        count = issue.input instanceof Set ? issue.input.size : 1
        break
      default:
        count = 1
    }

    return {
      message: translate(`${origin}.max` as TranslationKey, {
        ...issue,
        context: issue.inclusive ? 'inclusive' : 'exclusive',
        count,
      }),
    }
  })
